import { useTranslation } from 'react-i18next';
import AnswerContainer from './answer-container';
import NovartisLiveChatButton from './novartis-live-chat-button';
import { IQuestionOption, IMessage } from '../../common/types';

interface AnswerChoicesProps {
  message: IMessage;
  onSelectChoice: (choice: IQuestionOption | undefined) => void;
}

function AnswerChoices(props: AnswerChoicesProps) {
  const { t } = useTranslation();
  const choices = props.message?.choices;

  if (!choices) {
    return <>{t('chat.response.no_options')}</>;
  }

  const shouldShowSingleInfoserviceChoice =
    choices.length === 1 && choices[0]?.status === 'infoservice';

  return (
    <AnswerContainer>
      <div>{props.message?.message}</div>
      <ul className="block list-disc my-4 pl-5">
        {choices.map((choice, idx) => {
          if (!choice) {
            return null;
          }
          if (choice.status === 'infoservice' && !shouldShowSingleInfoserviceChoice) {
            return null;
          }

          return (
            <li key={idx}>
              <p
                className="cursor-pointer text-blue-600 underline"
                onClick={() => props.onSelectChoice(choice)}
              >
                {choice.actualQuery}
              </p>
            </li>
          );
        })}
      </ul>
      {t('chat.response.no_suitable_answer')} <br />
      <p
        className="cursor-pointer text-blue-600 underline"
        onClick={() => props.onSelectChoice(undefined)}
      >
        {t('chat.response.contact_medical_info')}
      </p>
      <NovartisLiveChatButton query={props.message.questionQuery} />
      {choices.length === 0 && `, ${t('chat.response.ask_new')}`}
    </AnswerContainer>
  );
}

export default AnswerChoices;
